import { HttpParams } from '@angular/common/http'
import { Component, effect, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap'

import { BaseComponent, Grid, ListItem, ModalBackDrop, ModalSize } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { WorkOrderDetailsComponent } from './work-order-details/work-order-details.component'

@Component({
    templateUrl: './scheduling.component.html',
    standalone: true,
    imports: [
        NgbNav,
        NgbNavItem,
        NgbNavItemRole,
        NgbNavLink,
        NgbNavLinkBase,
        NgbNavContent,
        NgbNavOutlet,
        FormsModule,
        WjInputModule,
        WjGridModule,
        WjGridFilterModule,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        GridExportComponent,
        AutoSizeDirective,
    ],
})
export class SchedulingComponent extends BaseComponent {
    active = 1
    mechanics: any[] = []
    mechanicsList: ListItem<number>[] = []
    selectedMechanic = signal(-1)
    workOrders: any[] = []
    workOrdersGrid: Grid<any>

    constructor() {
        super()

        this.workOrdersGrid = new Grid<any>(this.services, 'workOrder', this)
            .wrapColumnHeaders()
            .isReadOnly(true)
            .filterBy(item => [item.workOrder, item.description, item.mechanic, item.equipment, item.equipmentDescription])
            .doInitialSelection(false)

        // Effect to load work orders when selectedMechanic changes
        effect(() => {
            const mechanicId = this.selectedMechanic()
            this.loadWorkOrders(mechanicId)
        })

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/VpData/QueryMechanics')).subscribe({
                next: result => {
                    this.initialLoadingComplete()
                    this.mechanics = result[0]
                    this.mechanicsList = [
                        new ListItem<number>(-1, 'All Mechanics'),
                        ...this.mechanics.map(m => new ListItem<number>(m.id, m.name)),
                    ]
                },
            }),
        )
    }

    loadWorkOrders(mechanicId: number) {
        const params = new HttpParams().set('hrref', mechanicId.toString())
        this.cancelableRequest(
            'workOrders',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/VpData/QueryWorkOrders', params)).subscribe({
                next: result => {
                    this.workOrders = result[0]
                    this.workOrdersGrid.items = result[0]
                },
            }),
        )
    }

    tabChanged() {
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'))
        }, 50)
    }

    openWorkOrderDetails(workOrder: any) {
        const ref = this.services.modals.open(WorkOrderDetailsComponent, ModalSize.full95Percent, ModalBackDrop.darkAndActive)
        const instance = ref.componentInstance as WorkOrderDetailsComponent
        instance.workOrder = workOrder.workOrder
        instance.equipmentId = workOrder.equipment
        // The refresh() function will be called automatically in ngOnInit
        ref.result.then(
            () => {
                // Modal was closed
            },
            () => {
                // Modal was dismissed
            },
        )
    }
}
